/** Tipo de uma coluna do catálogo de exportação; espelha `ColumnType` do backend e decide como o valor é desenhado. */
export enum ColumnType {
  TEXT = 'TEXT',
  MONEY = 'MONEY',
  QUANTITY = 'QUANTITY',
  INTEGER = 'INTEGER',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  BOOLEAN = 'BOOLEAN',
  ENUM = 'ENUM',
  PERCENTAGE = 'PERCENTAGE',
}
